<template>
  <div>
    <slick ref="videoSlider" :options="videoSlider" class="video-slider">
      <div v-for="(data, index) in testimonialsData" :key="index">
        <div class="video-card">
          <!-- <a to data-fancybox :href="data.link">
            <div class="video-icon">
              <img src="@/assets/imgs/video-icon.svg" class="img-fluid" />
            </div>
          </a>   -->

          <iframe
            width="100%"
            height="315px !important"
            :src="'https://www.youtube.com/embed/' + data.link.split('=')[1]"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <!-- <div class="video-content">
              <div class="title">Sam Tagore</div>
              <div class="content">
                Masters in Computer Science <br />
                University of Oxford , England
              </div>
            </div> -->
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
  import { BModal } from "bootstrap-vue";

  // import Calendly from "vue-calendly";
  // import "https://assets.calendly.com/assets/external/widget.js"

  export default {
    name: "VideoTestimonialSlider",
    components: {
      BModal,
    },
    data() {
      return {
        videoSlider: {
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          // autoplay: true,
          // autoplaySpeed: 0,
          // speed: 5000,
          // cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
      };
    },
    props: {
      testimonialsData: {
        type: Array,
        default: "",
      },
    },
    methods: {},
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/VideoTestimonialSlider.vue